import { render, staticRenderFns } from "./VendorPartnersLayout.vue?vue&type=template&id=2dbe6a04&"
import script from "./VendorPartnersLayout.vue?vue&type=script&lang=js&"
export * from "./VendorPartnersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbe6a04')) {
      api.createRecord('2dbe6a04', component.options)
    } else {
      api.reload('2dbe6a04', component.options)
    }
    module.hot.accept("./VendorPartnersLayout.vue?vue&type=template&id=2dbe6a04&", function () {
      api.rerender('2dbe6a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/VendorPartnersLayout.vue"
export default component.exports